export const Status = Object.freeze({
  IDLE: 'idle',
  SUCCESS: 'success',
  EXPIRED: 'expired',
  INVALID: 'invalid',
  ERROR: 'error',
  REVALIDATE: 'revalidate'
})

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60)
  const secs = seconds % 60
  
  return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
}

export const INITIAL_TIME_LEFT = 1800 // expresado en segundos